import { Upload, message } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

const maxMegabytes = 15;
const maxBytes = maxMegabytes * 1024 * 1024;

const hasPdfType = (file: File) => file.type === 'application/pdf';
const hasPdfExtension = (file: File) =>
  file.name.toLowerCase().endsWith('.pdf');
const withinSizeLimit = (file: File) => file.size <= maxBytes;

const acceptable = (file: File) =>
  (hasPdfType(file) || hasPdfExtension(file)) && withinSizeLimit(file);

type CertificatePdfUploadProps = {
  children: React.ReactNode;
  onAccepted: (file: File) => void;
};

const CertificatePdfUpload: React.FC<CertificatePdfUploadProps> = ({
  children,
  onAccepted,
}) => {
  const { t } = useTranslation();

  const screen = (file: File) => {
    if (acceptable(file)) {
      onAccepted(file);
    } else {
      message.error(
        t('components.CertificatePdfUpload.rejected', { maxMegabytes }),
      );
    }
    return Upload.LIST_IGNORE;
  };

  return (
    <Upload
      accept="application/pdf,.pdf"
      beforeUpload={screen}
      maxCount={1}
      showUploadList={false}>
      {children}
    </Upload>
  );
};

export default CertificatePdfUpload;
